import { withAuditoryDigitalData } from '../auditory/provider/hooks';

const ERROR_DESCRIPTION_04 = 'INTERNAL SERVER ERROR';
const ERROR_TYPE_04 = 'Error interno del servicio';
const CHECKOUT_ERROR = 'Error checkout';
const BASE_URL = '/comprar/seguro-salud-flexible/page-error-';
const REPLACE_SALUD = 'seguro-salud';
const REPLACE_SALUD_FLEX = 'seguro-salud-flexible';

export const getTagDigitalID = (id) => window.digitalData.push({
  audience: {
    id,
    authState: 'Authenticated',
  },
  event: 'trackAudience',
});

export const getTagApplication = (product, leadid, event, phone, document) => {
  const objRequest = {
    application: {
      product,
    },
    contact: {
      leadid,
    },
    event,
  };

  if (phone && document) {
    objRequest.contact.phone = phone;
    objRequest.contact.document = document;
  }
  return window.digitalData.push(objRequest);
};

export const getTagMetadata = (key, value, event) => (
  window.digitalData.push({
    metadata: {
      key,
      value,
    },
    event,
  }));

export const getTagEvent = (event) => (
  window.digitalData.push({
    event,
  })
);

export const getTagError = (code, message, endpoint = '') => {
  if (endpoint !== '') {
    withAuditoryDigitalData({
      code,
      error: message,
      endpoint,
      urlPageError: '004',
      urlClient: window.location.href,
      pathClient: window.location.pathname,
    });
  }

  window.digitalData.push({
    error: {
      code,
      message,
    },
    event: 'trackError',
  });
};

export const getApiCanalTagError = (code, message, endpoint, typeError) => {
  if (Array.isArray(message)) {
    message.forEach((item) => {
      getTagError(code, item, endpoint);
    });
  } else {
    getTagError(code, message, endpoint);
  }
  getTagMetadata('Endpoint', endpoint, 'trackMetadata');
  getTagMetadata('TypeError', typeError, 'trackMetadata');
};

export const getTagVirtual = (name) => (
  window.digitalData.push({
    virtual: {
      name,
    },
    event: 'trackVirtual',
  })
);

export const getTagForm = (channel, name, event) => (
  window.digitalData.push({
    form: {
      channel,
      name,
    },
    event,
  })
);

export const getTagLog = (message, event) => (
  window.digitalData.push({
    log: {
      message,
    },
    event,
  })
);

export const getTagAction = (group, category, event1, label) => (
  window.digitalData.push({
    action: {
      group,
      category,
      option: event1,
      label,
    },
    event: 'trackAction',
  })
);

export const getTagActionName = (group, category, name, label, event) => (
  window.digitalData.push({
    action: {
      group,
      category,
      name,
      label,
    },
    event,
  })
);

export const getTagActionNameButton = (group, category, event1, label, event2) => (
  window.digitalData.push({
    action: {
      group,
      category,
      event: event1,
      label,
    },
    event: event2,
  })
);

export const getTagPayment = (
  id,
  amount,
  code,
  variant,
) => (
  window.digitalData.push({
    transaction: {
      id,
      store: 'Rimac Seguros Online',
      revenue: {
        amount,
        currency: '',
      },
      payment: {
        term: '',
        type: 'Tarjeta',
      },
      coupon: '',
      products: [{
        code,
        name: 'Seguro Salud Flexible',
        variant,
        brand: 'Rimac Seguros',
        price: amount,
        quantity: '1',
      }],
    },
    event: 'trackPurchase',
  })
);

export const sendMessageToApp = (label) => {
  // Envío de mensaje android
  console.log(label);
  // Envío de mensaje para ios
  if (window.webkit) {
    window.webkit.messageHandlers.MessageHandler.postMessage(label);
  }
};

const handleError = (apiId, endpoint, error, code = `${apiId}-04`, description = ERROR_DESCRIPTION_04) => {
  const url = `${BASE_URL}${code}`.replace(REPLACE_SALUD, REPLACE_SALUD_FLEX);
  getApiCanalTagError(code, description, endpoint, JSON.stringify(error));
  return url;
};

export const sendErrorWithResponse = (error, endpoint, apiId) => {
  const canal = localStorage.getItem('canal');
  if (canal) {
    sendMessageToApp('EMBEDDED-APP-STOP-ERROR-SERVICIO');
  }
  if (error && error.code && error.details) {
    try {
      const { code, details } = error;
      const { url, typeError, stack } = JSON.parse(details);
      getApiCanalTagError(code, stack, endpoint, typeError);
      return url.replace(REPLACE_SALUD, REPLACE_SALUD_FLEX);
    } catch (parseError) {
      return handleError(apiId, endpoint, `${parseError}-${error}`);
    }
  } else {
    return handleError(apiId, endpoint, error);
  }
};

export const sendErrorWithOutResponse = (apiId, endpoint) => {
  const canal = localStorage.getItem('canal');
  if (canal) {
    sendMessageToApp('EMBEDDED-APP-STOP-ERROR-SERVICIO');
  }
  const url = `/comprar/seguro-salud-flexible/page-error-${apiId}-04`;
  getApiCanalTagError(`${apiId}-04`, ERROR_DESCRIPTION_04, endpoint, ERROR_TYPE_04);

  return url;
};

export const sendPaymentError = (apiId, code, message, endpoint) => {
  const url = `/comprar/seguro-salud/page-error-${apiId}-${code}`;
  getApiCanalTagError(`${apiId}-${code}`, message, endpoint, CHECKOUT_ERROR);
  return url;
};

export const getTagFamily = (relationship, event) => (
  window.digitalData.push({
    family: {
      relationship,
    },
    event,
  })
);
